import React from 'react'
import Button from '../../../components/Button'
import styles from '../styles.module.scss'
import { MdSettings, MdPeople, MdPrint, MdSave } from 'react-icons/md'

export default function Footer({ goHome, onSettings, onTeachers, onPrint, onSave, onSaveAs }) {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLeft}>
        <Button className={styles.footerBtn} mode='white' onClick={onSettings}>
          <MdSettings size={14} />
          Настройки
        </Button>
        <Button className={styles.footerBtn} mode='white' onClick={onTeachers}>
          <MdPeople size={14} />
          Расписание преподавателей
        </Button>
        <Button className={styles.footerBtn} mode='white' onClick={onPrint}>
          <MdPrint size={14} />
          Печать
        </Button>
      </div>
      <div className={styles.footerRight}>
        <Button className={styles.footerBtn} mode='white' onClick={onSave}>
          <MdSave size={14} />
          Сохранить
        </Button>
        <Button className={styles.footerBtn} mode='white' onClick={onSaveAs}>
          <MdSave size={14} />
          Сохранить как...
        </Button>
        <Button className={styles.footerBtn} mode='white' onClick={goHome}>Закрыть</Button>
      </div>
    </footer>
  )
}
